import projectServices from "../Projects/projectServices";
import React, { Suspense, useEffect, useState } from 'react';
import Modal from "react-responsive-modal";

export default function BreackDown(param: any) {

    const returnValue = (e: any) => {
        param.closebreakDown(e)
        //setOpenFirst(false) 
    }

    const [BreakDownvalues, setBreakDownvalues] = useState<any>([]);
    const [payload, setpayload] = useState<any>([]);
    useEffect(() => {
        setBreakDownvalues(param.values)
        payload.action = 1; 
        payload.comment= "";
        payload.isAll= 0;
        payload.listContacts= [];
        payload.listContracts= [];
    }, []);

 //    console.log(param)

    const dpValues = (e: any) => {

        let value = Number(e);

        if (isNaN(value)) {
            value = 0.00;
        }
        return value?.toFixed(2);
    }


    const approveContract = (e: any) => {
        payload.action = 1;
        payload.periodFrom= 20191231;
        payload.periodTo= 20191231;
        payload.projectCode= param.project.projectCode;
        payload.projectId= param.project.projectId;
        projectServices.approveAllContracts(payload)
    }

    const unapproveContract = (e: any) => {
        payload.action = 2;
        payload.periodFrom= 20191231;
        payload.periodTo= 20191231;
        payload.projectCode= param.project.projectCode;
        payload.projectId= param.project.projectId;
        projectServices.approveAllContracts(payload)
    }

    const approveContact = (e: any) => {
        payload.action = 1;
        payload.listContacts = (param.values.contractAccountCode )
        projectServices.approveAllContracts(payload)
    }

    const unapproveContact = (e: any) => {
        payload.action = 2;        
        payload.listContacts = (param.values.contractAccountCode )
        projectServices.approveAllContracts(payload)
    }

    console.log( param)
    return (
        <>
            <Modal open={param.open} onClose={() => returnValue(1)} center>
                <div className="bgTransparent">
                    <div className="pull-right" style={{ maxWidth: "500px", minHeight: " 200px", fontWeight: "normal", color: "#47529" }}>
                        <div className="box borderThick">

                            <div className="box-header bg-blue">Royalties Breakdown</div>
                            <div className="box-content">

                                <table className="mb ">
                                    <tr>
                                        <td >Prior Period Balance</td>
                                        <td className="text-right ">{dpValues(BreakDownvalues.priorPeriodBal)}</td>
                                    </tr>
                                </table>
                                <table className="mb ">
                                    <tr>
                                        <td >Prior Period Payment</td>
                                        <td className="text-right ">{dpValues(BreakDownvalues.paymentsPer)}</td>
                                    </tr>
                                </table>
                                <table className="mb borderThick text-bold">
                                    <tr>
                                        <td >Opening Balance</td>
                                        <td className="text-right ">{dpValues(BreakDownvalues.openingBal)}</td>
                                    </tr>
                                </table>

                                <table className="mb borderThick text-bold">
                                    <tr>
                                        <td >Royalty Earnings</td>
                                        <td className="text-right ">{dpValues(BreakDownvalues.royaltyEarnings)}</td>
                                    </tr>
                                </table>
                                <table className="mb ">
                                    <tr>
                                        <td >Advances</td>
                                        <td className="text-right ">{dpValues(BreakDownvalues.totalsAdvances)}</td>
                                    </tr>
                                </table>
                                <table className="mb ">
                                    <tr>
                                        <td >Costs</td>
                                        <td className="text-right ">{dpValues(BreakDownvalues.costsPer)}</td>
                                    </tr>
                                </table>
                                <table className="mb ">
                                    <tr>
                                        <td >3rd Party Royalties</td>
                                        <td className="text-right ">{dpValues(BreakDownvalues.adjustments3rd)}</td>
                                    </tr>
                                </table>


                                <table className="mb borderThick text-bold">
                                    <tr>
                                        <td >Recoupables</td>
                                        <td className="text-right ">{dpValues(BreakDownvalues.recoupables)}</td>
                                    </tr>
                                </table>
                                <table className="mb ">
                                    <tr>
                                        <td >Reserve Held</td>
                                        <td className="text-right ">{dpValues(BreakDownvalues.reservesHeld)}</td>
                                    </tr>
                                </table>
                                <table className="mb ">
                                    <tr>
                                        <td >Reserve Released</td>
                                        <td className="text-right ">{dpValues(BreakDownvalues.reservesRel)}</td>
                                    </tr>
                                </table>


                                <table className="mb borderThick text-bold">
                                    <tr>
                                        <td >Net Reserve</td>
                                        <td className="text-right ">{dpValues(BreakDownvalues.netReserve)}</td>
                                    </tr>
                                </table>
                                <table className="mb ">
                                    <tr>
                                        <td >Manual Adjustments</td>
                                        <td className="text-right ">{dpValues(BreakDownvalues.adjustmentsMAN)}</td>
                                    </tr>
                                </table>
                                <table className="mb ">
                                    <tr>
                                        <td >Service/Admin Fee</td>
                                        <td className="text-right ">{dpValues(BreakDownvalues.adjustmentsSRV)}</td>
                                    </tr>
                                </table>


                                <table className="mb borderThick text-bold">
                                    <tr>
                                        <td >Adjustments</td>
                                        <td className="text-right ">{dpValues(BreakDownvalues.adjustments)}</td>
                                    </tr>
                                </table>

                                <table className="mb borderThick text-bold">
                                    <tr>
                                        <td >Closing Balance</td>
                                        <td className="text-right ">{dpValues(BreakDownvalues.closingBalance)}</td>
                                    </tr>
                                </table>

                            </div>

                            <div className="pull-left">
                                <div className="label-entries text-left mtl mb mll">
                                    Contract:
                                </div>
                                <div className="mll">
                                    <button className="hover-box btn-sm bg-level7 mb" onClick={approveContract}>
                                        <i className="icon-tick1" style={{ color: "#ffff" }}></i>
                                    </button>

                                    <button className="hover-box btn-sm bg-level10 mb" onClick={unapproveContract}>
                                        <i className="icon-close1" style={{ color: "#ffff" }}></i>
                                    </button>
                                </div>
                            </div>

                            <div className="pull-right">
                                <div className="label-entries mtl mb mrl">
                                    Contact:
                                </div>

                                <div className="pull-right mrl">
                                    <button className="hover-box btn-sm bg-level7 mb" onClick={approveContact}>
                                        <i className="icon-tick1" style={{ color: "#ffff" }}></i>
                                    </button>
                                    <button className="hover-box btn-sm bg-level10 mb" onClick={unapproveContact}>
                                        <i className="icon-close1" style={{ color: "#ffff" }}></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    )
}